// Walks the rendered DOM of a textbox HTML fragment and produces the plain-text
// representation used for kerning offset math: text nodes contribute their
// content, <br> contributes "\n", everything else recurses transparently.
export const plainTextFromHTML = (html: string): string => {
  if (!html) return "";

  const tmp = document.createElement("div");
  tmp.innerHTML = html;

  const out: string[] = [];
  const walk = (node: Node): void => {
    for (const child of Array.from(node.childNodes)) {
      if (child.nodeType === Node.TEXT_NODE) {
        out.push(child.nodeValue ?? "");
      } else if (child.nodeType === Node.ELEMENT_NODE) {
        if ((child as Element).nodeName === "BR") {
          out.push("\n");
        } else {
          walk(child);
        }
      }
    }
  };
  walk(tmp);

  return out.join("");
};
